export function TabItem({ className, item, setActiveTab, tabIndex }) {
  const { button, show } = item;
  const { icon, label, onClick } = button;

  if (!show) return null;

  return (
    <div className={className}>
      <button
        onClick={() => {
          setActiveTab(tabIndex);
          onClick();
        }}
        type="button"
      >
        <span className="sr-only">{label}</span>
        {icon}
      </button>
    </div>
  );
}
